import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, NavigationExtras, Router, RouterStateSnapshot } from '@angular/router';
import { Location} from '@angular/common';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {

  constructor(public auth: AuthService, public router: Router, private location: Location) { }

  getParamsFromURI(uri: string) {
    // Get everything after the `?`
    const [, paramString] = uri.split('?');

    // Return parameters
    return Object.fromEntries(new URLSearchParams(paramString).entries());
  };

  getResolvedUrl(route: ActivatedRouteSnapshot): string {
    return route.pathFromRoot
      .map(v => v.url.map(segment => segment.toString()).join('/'))
      .join('/');
  }

  fullRedirect(commands: any[], extras: NavigationExtras) {
    const urlTree = this.router.createUrlTree(commands, extras);
    const path = this.location.prepareExternalUrl(urlTree.toString());
    const url = window.location.origin + path;
    window.location.href = url;
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    // TODO: confirm user has access to route by making a route:scope dictionary
    const isAuthorizeRequest = this.getResolvedUrl(route) == "/authorize";
    const params = isAuthorizeRequest ? this.getParamsFromURI(state.url) : {};
    params['next'] = state.url;

    const orgId = params['orgId'] ? Number(params['orgId']) : null;
    if (!this.auth.isAuthenticated() || (isAuthorizeRequest && (!orgId || this.auth.getOrgId() != orgId))) {
      params['cb'] = (Math.floor(Math.random() * 10000)).toString();
      this.fullRedirect(['login'], { queryParams: params });
      return false;
    }
    return true;
  }
}
